import moment from 'moment';
import restService from './rest.service'

async function getDosesPacienteAsync() {
    const { data } = await restService.postAsync('vacinas/getDosesPaciente', {});
    return data;
}

async function getCarteiraVacinacaoAsync() {
    return restService.downloadAsync('vacinas/getCarteiraVacinacao', {
        mime: 'application/pdf',
        title: `CarteiraVacinacao_${moment().format('YYMMDDHms')}.pdf`
    });
}

export default { getDosesPacienteAsync, getCarteiraVacinacaoAsync }